import { render } from "./TransitParcels.vue?vue&type=template&id=019a8375&scoped=true"
import script from "./TransitParcels.vue?vue&type=script&lang=js"
export * from "./TransitParcels.vue?vue&type=script&lang=js"

import "./TransitParcels.vue?vue&type=style&index=0&id=019a8375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019a8375"]])

export default __exports__